import React from 'react'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import s from './index.css'

class PrivacyPolicy extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isAgree: false,
      isShow: false,
    }
  }

  componentDidMount() {
    const isAgree = localStorage.getItem('web_privacy_agree')

    this.setState({
      isAgree: !!isAgree,
      isShow: true,
    })
  }

  agreeOpt = () => {
    localStorage.setItem('web_privacy_agree', 'true')
    this.setState({
      isAgree: true,
    })
  }

  disagreeOpt = () => {
    this.setState({
      isShow: false,
    })
  }

  render() {
    const { isAgree, isShow } = this.state

    if (!isAgree && isShow) {
      return (
        <div className={s.privacyContainer}>
          <div>
            <div className={s.listTitle}>感谢您对有道精品课的关注！</div>
            {/* <div className={s.list}>为了给您提供更好的学习体验，我们可能会获取部分必要信息。</div> */}
            <div className={s.list}>
              为了给您提供更好的学习体验，请您认真阅读<a className={s.privacyPolicy} href="https://c.youdao.com/xue/legal.html">隐私政策</a>、<a className={s.privacyPolicy} href="https://c.youdao.com/xue/agreement.html">服务条款</a>与<a className={s.privacyPolicy} href="https://c.youdao.com/xue/wap/aftersale.html">售后政策</a>。如果您是未满18 周岁的未成年人，请通知您的监护人共同阅读<a className={s.privacyPolicy} href="http://c.youdao.com/xue/teenager.html">未成年人个人信息保护规则</a>。点击“同意”视为接受全部条款，开始享受有道精品课的服务吧〜
            </div>
          </div>
          <div className={s.oprate}>
            <div
              role={'button'}
              className={`${s.disagree} ${s.btn}`}
              onClick={this.disagreeOpt}
            >不同意</div>
            <div
              role={'button'}
              className={`${s.agree} ${s.btn}`}
              onClick={this.agreeOpt}
            >同意</div>
          </div>
        </div>
      )
    }

    return null
  }
}

export default withStyles(s)(PrivacyPolicy)



// WEBPACK FOOTER //
// ./src/components/p_home/PrivacyPolicy/index.js